import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import VisibilityIcon from '@mui/icons-material/Visibility';
import McPreferences from '../Component/Dialogs/McPreferences';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getConsentGroupData, transferObject } from '../store/actions/CommonAction';
import EditIcon from '@material-ui/icons/Edit';
import RiDraftFill from "@material-ui/icons/Edit";
import CheckBoxSharpIcon from '@material-ui/icons/CheckBoxSharp';
import { ToastContainer, toast } from 'react-toastify';


const ConsentGroup = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const consentGroups = useSelector(state => state.common.getConsentGroupData);
  const getProductTheme = useSelector(state => state.common.getProductTheme);
  const clientId = useSelector(state => state.common.clientId);
  
  const [openMcPreferences, setOpenMcPreferences] = useState(false);
  const [values, setValues] = useState({
      select1: '',
      select2: '',
  });

  useEffect(() => {
    if(!sessionStorage.getItem('sessionId')){
      toast.error(`Your Session has Expired: Please login again`);
      window.location.href = '/login';
  }
    async function fetchData() {
      try {
        await dispatch(getConsentGroupData(clientId));
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, [dispatch, clientId]);

  useEffect(() => {
    // Add body class when component mounts
    document.body.classList.add('manage');
    // Remove body class when component unmounts
    return () => {
      document.body.classList.remove('manage');
    };
  }, []);

  const handleObjectTransfer = (consentGroupElement) => {
    try {
      const { consentGroupId } = consentGroupElement;
      var arrayToSend = [];
      for (let template of consentGroupElement.templates) {
        const consentTypes = template && template.consentTypes ? template.consentTypes : [];
        const nickName = template && template.nickName ? template.nickName : '';
        const dataTypes = template && template.dataTypes ? template.dataTypes : [];
        const dataConsumer = template && template.dataConsumer ? template.dataConsumer : [];
        const dataProvider = template && template.dataProvider ? template.dataProvider : [];
        const purpose = template && template.purpose ? template.purpose : [];
        const consentValidity = template && template.consentValidity ? template.consentValidity : {};
        const shared = template && template.shared ? template.shared : false;
        const mandatory = template && template.mandatory ? template.mandatory : false;

        const formData = {
          consentGroupId: consentGroupId,
          consentGroupName: consentGroupElement.consentGroupName,
          itemKey: 0,
          consentMode: 'STORE',
          fetchType: 'PERIODIC',
          consentTypes: consentTypes,
          nickName: nickName,
          dataTypes: dataTypes,
          dataConsumer: dataConsumer,
          dataProvider: dataProvider,
          purpose: purpose,
          consentValidity: consentValidity,
          DataLife: { 'unit': 'YEAR', 'value': 1 },
          Frequency: { 'unit': 'YEAR', 'value': 1 },
          shared: shared,
          mandatory: mandatory,
          format: ''
        };
        arrayToSend.push(formData);
      }

      console.log("arrayToSend : "+JSON.stringify(arrayToSend));
      const targetUrl = `/createConsentGroup/${encodeURIComponent('draft')}`;
      dispatch(transferObject(arrayToSend));
      history.push(targetUrl);
    } catch (error) {
      console.error('An error occurred during object transfer:', error);
    }
  };

  const handleChange = (event) => {
      const { name, value } = event.target;
      setValues({
          ...values,
          [name]: value,
      });
  };

  useEffect(() => {
    // Add body class when component mounts
    document.body.classList.add('manage');
    // Remove body class when component unmounts
    return () => {
      document.body.classList.remove('manage');
    };
  }, []);

  return (
    <>

      {/* <section className='content-header'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-12'>
              <h1 className='page-title'>
                Manage Consent Group
                <span>We will help you to manage consent groups.</span>
              </h1>
            </div>
          </div>
        </div>
      </section> */}
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px', marginTop:'10%' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <section className='content h-100'>
          <div className='container' style={{marginTop:'10%',marginBottom:'2%'}}>
            <div className='row'>
              <div className='col-md-12'>
                <div class="card custom-cards">
                  <div class="card-body">
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='table-responsive'>
                          <table class='table'>
                            <thead>
                              <tr>
                                <th scope='col'>S. No.</th>
                                <th scope='col'>Consent Group Name</th>
                                <th scope='col'>Consent Group ID</th>
                                <th scope='col'>Status</th>
                                
                              </tr>
                            </thead>
                            <tbody>
                              {/* {consentGroups && consentGroups.length > 0 ? (
                                consentGroups.map((element, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{element.consentGroupName}</td>
                                    <td>{element.consentGroupId}</td>
                                    <td>
                                     */}
                                     {consentGroups && consentGroups.length > 0 ? (
                                     consentGroups.map((element, index) => (
         <tr key={index}>
      <td>{(index + 1).toString().padStart(2, '0')}</td>
      <td>{element.consentGroupName}</td>
      <td>{element.consentGroupId}</td>
      <td>
                                      {element.status === 'DRAFT' ? (
                                        <>
                                        <span className='status revoked'>
                                        {element.status}
                                      </span>
                                      <button type="button" className='btn-view' onClick={()=>handleObjectTransfer(element)}><EditIcon className='editLink'/>Edit</button>
                                      
                                      </>
                                      ) : (
                                        // <span style={{ color: 'green' }}>
                                        //   <CheckBoxSharpIcon />&nbsp;{element.status}
                                        // </span>
                                        
                                      <span className='status active'>{element.status}</span>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="4">No consent groups found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className='row mt-2 justify-content-between'>
                      <div className='col-md-auto me-auto '>
                        <div className='dt-info'>
                          {consentGroups &&
                                consentGroups.length > 0 ? (
                                  <div className="dt-info">
                                    Showing 1 to {consentGroups.length} entries of {consentGroups.length} entries
                                  </div>
                                ) : (
                                  <div>
                                    {consentGroups && consentGroups 
                                      ? `${consentGroups.length} entries present`
                                      : "No entries present"}
                                  </div>
                                )}
                        </div>
                      </div>
                      
                    </div>
                    <div className='row justify-content-between align-items-center'>
                      <div className='col-md-6'>
                        {/* <h5 className='card-title'>
                          Data Distribution Graph
                        </h5> */}
                      </div>
                      {/* <div className='col-md-6 text-end'>
                        <a href='#!' className='chart-toggler' onClick={() => setOpenMcPreferences(true)}>
                          <VisibilityIcon />
                          &nbsp;Show Preferences
                        </a>
                      </div> */}
                    </div>
                    <div className='row mt-3'>
                      <div className='col-md-12'>
                        <div className='chart-container'>
                          {/* Place the chart component here */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    
      )}
      {openMcPreferences && (
        <McPreferences 
          open={openMcPreferences} 
          handleClose={() => setOpenMcPreferences(false)} 
          title="Manage Chart Preferences"
          handleApply={(preferences) => {
            // Handle applying preferences
            console.log(preferences);
            setOpenMcPreferences(false);
          }}
        />
      )}
    </>
  );
};

export default ConsentGroup;
